import styled from 'styled-components'
import { Modal as AntModal } from 'antd'

import type { T_ModalProps } from './modal'


export const SC_Modal = styled(
  (props: T_ModalProps) => <AntModal {...props} />
)`
  .ant-modal-content {
    padding-top: 40px;
    border-radius: 24px;
    text-align: center;
    display: flex;
    justify-content: center;
    flex-direction: column;

    h3 {
      font-weight: 500;
      white-space: pre-line;
    }
  }

  .ant-modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
  }

  &.ant-modal-root .ant-modal {
    max-width: calc(100vw - 32px);
    margin: 8px auto;

    @media (min-width: 520px) {
      max-width: 544px;
    }
  }
`
